import { AssistantStatusIndicator } from 'src/components/assistant/AssistantStatusIndicator';
import { ChannelTypingIndicator } from 'src/components/chat/inner-channel/channel-content/ChannelTypingIndicator';

interface ChannelStatusIndicatorsProps {
  aiAssistantStatus?: {
    status: string;
    metadata?: {
      tool?: string;
      query?: string;
    };
  } | null;
  typingStatus?: {
    typingUsers: Array<{
      user?: {
        id?: string;
        name?: string;
      };
    }>;
  } | null;
  isInternalChat?: boolean;
  getCompanyFromId?: (companyId: string) => { name?: string } | null;
  getClientFromId?: (clientId: string) => { name?: string } | null;
  clearAIAssistantStatus?: () => void;
}

export const ChannelStatusIndicators = ({
  aiAssistantStatus,
  typingStatus,
  isInternalChat = false,
  getCompanyFromId,
  getClientFromId,
  clearAIAssistantStatus,
}: ChannelStatusIndicatorsProps) => {
  const hasAIStatus = !!aiAssistantStatus;
  const hasTyping = !!typingStatus;

  // If we have AI status or typing, show unified container
  if (hasAIStatus || hasTyping) {
    return (
      <div
        className={`sticky bottom-0 z-10 ${isInternalChat ? 'px-4' : 'pl-4 pr-9'}`}
      >
        <div className="flex flex-col bg-gray-150 rounded-lg px-3 py-2 gap-1">
          {aiAssistantStatus && (
            <AssistantStatusIndicator
              status={aiAssistantStatus.status}
              metadata={aiAssistantStatus.metadata}
              getCompanyFromId={getCompanyFromId}
              getClientFromId={getClientFromId}
              onClearStatus={clearAIAssistantStatus}
            />
          )}
          {typingStatus && (
            <ChannelTypingIndicator typingUsers={typingStatus.typingUsers} />
          )}
        </div>
      </div>
    );
  }

  return null;
};
